<template>
  <div class="upload-list-box dialog-primary" v-show="visible">
    <div class="header dialog-header">
      <div class="title">上传列表</div>
      <div class="close-btn">
        <span class="icon" @click="closeDialog">
          <i class="el-icon-close" />
        </span>
      </div>
    </div>
    <div class="dialog-content">
      <div class="clear-btn-box">
        <div class="common-button-box">
          <el-button
            class="primary-btn"
            type="primary"
            size="small"
            @click="clearWaitngFiles"
          >
            一键清理
          </el-button>
        </div>
      </div>
      <div class="common-table-box">
        <el-table
          highlight-selection-row
          class="publish-table publish-small-table custom-table"
          :header-row-class-name="customHeaderK"
          ref="modelTable"
          height="100%"
          size="mini"
          v-loading="tableLoading"
          :data="fileUploadList"
        >
          <el-table-column
            label="序号"
            type="index"
            width="75"
          ></el-table-column>
          <el-table-column label="文件名称" width="240">
            <template v-slot="{ row }">
              <span class="text-overflow" :title="row.fileName">
                {{ row.fileName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="100">
            <template v-slot="{ row }">
              <span>
                {{
                  `${formatFileSize(row.length).fileSize}${
                    formatFileSize(row.length).unit
                  }`
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="上传进度" width="270">
            <template v-slot="{ row }">
              <div v-if="row.status === -1 || row.status === -2">
                <span class="wating-text transform-waiting">
                  <i class="el-icon-time icon" />
                  等待上传
                </span>
              </div>
              <div v-else-if="row.status === -3">
                <span class="wating-text transform-waiting">
                  <i class="el-icon-time icon" />
                  等待更新
                </span>
              </div>
              <div v-else-if="row.status === 5">
                <span class="error-text transform-fail">
                  <span :title="`${checkResultMap[row.checkResult]}`">
                    解析失败
                  </span>
                  <icon-svg
                    icon-class="ic-zaicijiexi"
                    class="recheck-icon"
                    title="重新解析"
                    @click.native="reCheck(row)"
                  />
                </span>
              </div>
              <div v-else-if="row.status === 7">
                <span class="error-text transform-fail">
                  <i class="el-icon-error icon" />
                  上传失败
                </span>
              </div>
              <ProgressBar
                v-else
                :fileInfo="row"
                :uploadControl="uploadControl"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="90">
            <template v-slot="{ row }">
              <div class="operation-cell">
                <el-button
                  title="删除"
                  type="text"
                  size="small"
                  :disabled="row.status === 1"
                  @click="deleteFileById(row)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar.vue";

import { Store } from "@/utils/store";

import { formatFileSize, getToken } from "@/utils/generalMethods";

import {
  getFileList,
  deleteFileService,
  reCheckFileService,
} from "@/service/interface";

export default {
  data() {
    return {
      visible: false,
      fileUploadList: [],
      timer: null,
      tableLoading: false,
      checkResultMap: {
        RvtGet3DError: "三维视图读取失败",
        DemConstructError: "文件格式错误",
        DemUnZipError: "解压失败",
        OsgbConstructError: "文件格式错误",
        OsgbUnZipError: "解压失败",
        CadError: "解析失败",
        VectorUploadError: "矢量解析失败",
      },
      customHeaderK: "",
    };
  },
  components: {
    ProgressBar,
  },
  mounted() {
    const currentBody = this.$refs.modelTable.bodyWrapper;
    currentBody.addEventListener("scroll", (ev) => {
      const scrollTop = ev.target.scrollTop;
      this.customHeaderK = scrollTop > 10 ? "darkHeader" : "";
    });
    this.$eventManage.on("startUploadFile", this.onStartUploadFile);
  },
  beforeDestroy() {
    this.destroyInterval();

    this.$eventManage.off("startUploadFile", this.onStartUploadFile);
  },
  watch: {
    $route(to, from) {
      let path = to.path;
      if (
        !path.includes("dataManage") &&
        this.isChecked("Project.Single.File.List")
      ) {
        this.destroyInterval();
        this.visible = false;
      }
    },
  },
  methods: {
    clearWaitngFiles() {
      let waitingFiles = this.fileUploadList.filter(
        (el) => el.status === -1 || el.status === -2
      );
      if (!waitingFiles.length) {
        this.$message.warning("当前没有等待上传的文件，无需清理");
        return;
      }

      let warningMsg = "";
      if (waitingFiles.length === this.fileUploadList.length) {
        warningMsg = "确定清理所有等待上传的文件？";
      } else {
        // prettier-ignore
        warningMsg = "仅支持清理等待上传的文件，其他文件将跳过，确定清理等待上传的文件？";
      }

      this.$confirm(warningMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          waitingFiles.forEach((fileInfo) => {
            // prettier-ignore
            let find = Store.uploaders.find((el) => el.schemeType === fileInfo.schemeType);
            if (find) {
              let uploadFiles = find.uploader.uploadFiles;
              let findIndex = uploadFiles.findIndex((el) =>
                this.isSameFile(el, fileInfo)
              );
              if (findIndex !== -1) {
                uploadFiles.splice(findIndex, 1);
              }
            }
          });

          this.refreshFileList();
        })
        .catch((error) => {
          console.log("An error occurred:", error);
        });
    },
    onStartUploadFile() {
      this.visible = true;

      this.tableLoading = true;
      this.queryFilesUpload().then(() => {
        this.tableLoading = false;
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000);
        }
      });
    },
    refreshUploadList() {
      this.tableLoading = true;
      this.queryFilesUpload().then(() => {
        this.tableLoading = false;
        if (!this.timer) {
          this.timer = setInterval(this.refreshFileList, 1000);
        }
      });
    },
    deleteFileById(fileInfo) {
      if (fileInfo.status < 0) {
        let find = Store.uploaders.find(
          (el) => el.schemeType === fileInfo.schemeType
        );
        if (find) {
          let uploader = find.uploader;
          let findIndex = uploader.uploadFiles.findIndex(
            (el) =>
              this.isSameFile(el, fileInfo) &&
              el.dataSetId === fileInfo.dataSetId
          );
          if (findIndex !== -1) {
            uploader.uploadFiles.splice(findIndex, 1);
          }
        }
        return;
      }

      let fileDataId = fileInfo.id;
      deleteFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.$message.success("删除成功");
          this.refreshUploadList();
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    uploadControl(fileInfo) {
      let find = Store.uploaders.find(
        (el) => el.schemeType === fileInfo.schemeType
      );
      if (find) {
        let uploader = find.uploader;
        let fileStatus = fileInfo.status;
        if (fileStatus === 1) {
          uploader.fire("pauseFileUpload", { fileInfo, uploader });
        }
        if (fileStatus === 2) {
          uploader.setStatus("continue");
          uploader.setCurrDataSetId(fileInfo.dataSetId);
          uploader.setCurrFileInfo(fileInfo);

          let pausedFiles = uploader.pausedFiles;
          let findPauseFile = pausedFiles.find(
            (el) => el.fileDataId === fileInfo.fileDataId
          );
          if (findPauseFile) {
            uploader.fire("continueFileUpload", { fileInfo });
          }
        }
      }
    },
    refreshFileList() {
      this.queryFilesUpload().then(() => {
        let validFiles = this.fileUploadList.filter(
          (el) => el.status !== 5 && el.status !== 7
        );
        if (validFiles.length) {
          this.refreshDom();
        } else {
          this.destroyInterval();
        }
      });
    },
    queryFilesUpload() {
      return new Promise((resolve) => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          name: "",
          status: [0, 1, 2, 5, 6, 7, 8],
        };
        getFileList(params).then((response) => {
          if (response.isSuccess) {
            let result = response.data;
            let fileUploadList = result.items;

            // 从上传列表中移除构件库上传的文件
            // prettier-ignore
            const schemeTypes = ["CLPrivateDoc", "CLPublicDoc", "Rvtuv","Capability", 'SceneAnnotationAttachment',"SceneAnchorPointAttachment"];
            fileUploadList = fileUploadList.filter(
              (el) => !schemeTypes.includes(el.scheme)
            );
            let uploaders = Store.uploaders.filter(
              (el) => !schemeTypes.includes(el.schemeType)
            );

            fileUploadList.forEach((item) => {
              let bussinessInfo = item.fileBusinessInfo
                ? item.fileBusinessInfo
                : {};
              item["schemeType"] = item.scheme;
              item["dataSetId"] = bussinessInfo.dataSetId;
              item["status"] = item.uploadStatus;
              item["length"] = item.size;

              item["fileDataId"] = item.id;
              item["fileId"] = bussinessInfo.fileId;
              if (item.blobIndex || item.blobIndex === 0) {
                let rate = ((item["blobIndex"] + 1) / item.blobCount) * 10000;
                rate = Math.floor(rate);
                item["rate"] = rate;
              }
            });
            fileUploadList = fileUploadList.filter((el) => el.isAuthorized);

            // 前端的上传文件列表
            let customUploadList = [];
            uploaders.forEach((uploader) => {
              let uploadFiles = uploader.uploader.uploadFiles;
              let uploadingFiles = uploader.uploader.uploadingFiles;

              customUploadList = [
                ...uploadingFiles,
                ...uploadFiles,
                ...customUploadList,
              ];
            });

            customUploadList.forEach((item) => {
              let findIndex = fileUploadList.findIndex(
                (el) =>
                  el.fileName === item.fileName &&
                  el.dataSetId === item.dataSetId
              );
              if (findIndex === -1) {
                fileUploadList.push(item);
              } else {
                let status = fileUploadList[findIndex].status;
                // 如果后端接口返回的状态不是上传中，则按前端状态显示
                if (status !== 1) {
                  fileUploadList[findIndex].status = item.status;
                }
              }
            });

            this.fileUploadList = fileUploadList;
            resolve();
          }
        });
      });
    },
    reCheck(fileInfo) {
      let fileDataId = fileInfo.id;
      reCheckFileService(fileDataId).then((response) => {
        if (response.isSuccess) {
          this.refreshFileList();
          if (!this.timer) {
            this.timer = setInterval(this.refreshFileList, 3000);
          }
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    isSameFile(fileInfo1, fileInfo2) {
      return (
        fileInfo1.fileName === fileInfo2.fileName &&
        fileInfo1.length === fileInfo2.length
      );
    },
    refreshDom() {
      this.fileUploadList.forEach((item) => {
        let find = Store.uploaders.find(
          (el) => el.schemeType === item.schemeType
        );
        if (find) {
          let pausedFiles = find.uploader.pausedFiles;
          let findPauseFile = pausedFiles.find(
            (el) => el.fileDataId === item.id
          );
          if (item.status === 2 && !findPauseFile) {
            let continueDom = document.getElementById(`continue-${item.id}`);
            if (continueDom) {
              if (
                !continueDom.children[0] ||
                !continueDom.children[0].className.includes("webuploader-pick")
              ) {
                let uploader = find.uploader;
                uploader.uploader.addButton({
                  id: `#continue-${item.id}`,
                  multiple: false,
                });
              }
            }
          }
        }
      });
    },
    closeDialog() {
      this.destroyInterval();
      this.visible = false;
    },
    destroyInterval() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
    getToken,
    formatFileSize,
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";

.dialog-primary.upload-list-box {
  border: 1px solid var(--dailog-border-color) !important;
}
.upload-list-box {
  position: absolute;
  box-shadow: var(--base-bg-dark-color30);
  bottom: 16px;
  right: 16px;
  z-index: 4;
  border-radius: 16px 16px 0px 16px;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: var(--dialog-header-bg-color);
    border-radius: 8px 8px 0px 0px;

    .title{
      color: var(--dialog-header-text-color);
    }

    .close-btn {
      position: absolute;
      top: 8px;
      right: 15px;

      .icon {
        color: var(--default-color);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: var(--dialog-header-icon-bgColor);
        }
      }
    }
  }

  .clear-btn-box {
    text-align: left;
  }

  .common-table-box {
    height: 300px;
    margin-top: 16px;

    .custom-table {
      :deep(.el-table__body) {
        -webkit-border-vertical-spacing: 4px;
        border-collapse: separate; /* 必须设置为 separate 才生效 */
        border-spacing: 0 4px; /* 水平间距 0，垂直间距 6px */
      }
    }

    .error-text {
      font-size: 13px;
      color: #f56c6c;

      .icon {
        margin-right: 5px;
      }

      .recheck-icon {
        margin-left: 5px;
        cursor: pointer;
      }
    }

    .wating-text {
      font-size: 15px;
      color: #3588fa;
      .icon {
        margin-right: 10px;
      }
    }

    .button-icon {
      font-size: 18px;
      color: var(--icon-color);
      border: none;
      background: transparent;
      padding: 5px;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }

    .el-button.is-disabled {
      // color: rgba(255, 255, 255, 0.3);

      &:hover {
        background: transparent;
      }
    }
  }
}
</style>
